import iView from 'iview'
function notice (title, desc = '', type = 'info', duration = 2) {
  if (type == 'info') {
    iView.Notice.info({
      title: title,
      desc: desc,
      duration: duration
    })
  } else if (type == 'success') {
    iView.Notice.success({
      title: title,
      desc: desc,
      duration: duration
    })
  } else if (type == 'warning') {
    iView.Notice.warning({
      title: title,
      desc: desc,
      duration: duration
    })
  } else if (type == 'error') {
    iView.Notice.error({
      title: title,
      desc: desc,
      duration: duration
    })
  }
}

function message (des, type = 'success') {
  if (type == 'warning') {
    notice(des, '', 'warning')
    // iView.Message.warning(des)
  } else if (type == 'success') {
    notice(des, '', 'success')
    // iView.Message.success(des)
  } else if (type == 'error') {
    notice(des, '', 'error')
    // iView.Message.error(des)
  }
}

export {
  notice,
  message
}



// WEBPACK FOOTER //
// ./src/common/js/tip.js